module.exports = __webpack_public_path__ + "static/google-play-badge-d7c37170b7b7c579b0fbbbc1656a0b2a.png";